// @ts-nocheck

require('./ReleaseBasket.scss');
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Naskor } from '../../../../js/components/naskor';
import Table from './Table/Table';
import * as InterfaceCollection from './InterfaceCollection';
import ShippingAddress from '../../Basket/ShippingAddress/ShippingAddress';
import Divider from '../../Basket/Divider/Divider';
import LoadingSpinner from '../../../Abstracts/LoadingSpinner/LoadingSpinner';

export default function ReleaseBasket(props: any) {
  const [basket, setBasket] = useState<InterfaceCollection.VtsBasket | null>(
    null
  );
  const [placeOrderError, setPlaceOrderError] = useState<string | null>(null);
  const navigate = useNavigate();
  const uniqueRequestId = useRef<number | null>(null);
  const timeoutRef = useRef<any>(null);

  const loadBasketFromServer = useCallback(() => {
    const thisUnique = Math.random();
    uniqueRequestId.current = thisUnique;

    return Naskor.fetchJson('/api/onlineshop/vts-release-basket').then((b) => {
      if (uniqueRequestId.current === thisUnique) {
        setBasket(b);
        if (props.updateHeaderOrder) {
          props.updateHeaderOrder();
        }
        if (Object.keys(b).length === 0) {
          setTimeout(() => {
            loadBasketFromServer();
          }, 5000);
        }
      }
    });
  }, [props]);

  const handlePlaceOrder = useCallback(() => {
    setBasket(null);
    setPlaceOrderError(null);
    return Naskor.fetchJson(
      '/api/onlineshop/vts-release-basket/place-order'
    ).then((response) => {
      if (response.success === true) {
        // Provisorische Success-Bestätigung: Flag in URL, der
        // PlaceOrderSuccessBanner in der Zielview zeigt es an und räumt
        // den Param wieder auf.
        navigate('/vts-order?placed=1', { replace: true });
        if (props.defineView) {
          props.defineView();
        }
      } else {
        if (response?.error) {
          setPlaceOrderError(response.error);
        }
        loadBasketFromServer();
      }
    });
  }, [props, loadBasketFromServer, navigate]);

  const handleGoBack = useCallback(() => {
    setBasket(null);
    return Naskor.fetchJson('/api/onlineshop/remove-vts-release-basket').then(
      (response) => {
        if (response.success === true) {
          if (props.defineView) {
            props.defineView();
          }
        } else {
          loadBasketFromServer();
        }
      }
    );
  }, [props, loadBasketFromServer]);

  useEffect(() => {
    loadBasketFromServer();
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [loadBasketFromServer]);

  if (!basket || Object.keys(basket).length === 0) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="html--basket">
            <ShippingAddress
              erpShippingAddressId={basket.erp_shipping_address_id}
              refetchBasket={loadBasketFromServer}
              is_vts={true}
            />
            <Divider />
            {basket.brand_positions?.length > 0 ? (
              <Table basket={basket} reloadBasket={loadBasketFromServer} />
            ) : (
              <a
                className="basket-empty-note"
                href={'/virtual-trade-show/lobby'}
              >
                Unfortunately it is pretty empty here. Discover what can be
                ordered!
              </a>
            )}
            {placeOrderError && (
              <div className="row">
                <div className="col-sm-12 text-end">
                  <p className="text-danger mb-0">{placeOrderError}</p>
                </div>
              </div>
            )}
            {basket.total_quantity > 0 &&
              !basket.erp_shipping_address_id && (
                <div className="row">
                  <div className="col-sm-12 text-end">
                    <p className="text-danger mb-0">
                      Please select a shipping address before placing the
                      order.
                    </p>
                  </div>
                </div>
              )}
            <div className="row--placeorder d-flex justify-content-between align-items-center">
              <button onClick={handleGoBack} className="btn btn-primary">
                Go Back
              </button>
              {basket.total_quantity > 0 &&
              basket.erp_shipping_address_id > 0 ? (
                <button
                  onClick={handlePlaceOrder}
                  className="btn btn-primary"
                >
                  Place Order
                </button>
              ) : (
                <span
                  style={{
                    pointerEvents: 'none',
                    backgroundColor: '#333333',
                  }}
                  className="btn btn-primary"
                >
                  Place Order
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
